export default __webpack_public_path__ + "static/ak-cached/24h/media/email.e932e5fb.svg";